var $ = require('jquery');
var Marionette = require('backbone.marionette');
var template = require('./layout-template.hbs');

module.exports = Marionette.LayoutView.extend({
	template: template,
	className: 'overview container',
  regions: {
    map: '.overview__map',
    details: '.overview__details'
  },

	// onBeforeRender: function(){
	// 	console.log('=== Overview Layout onBeforeRender');
	// },
	// onBeforeShow: function(){
	// 	console.log('=== Overview Layout onBeforeShow');
	// },
	// onBeforeAttach: function(){
	// 	console.log('=== Overview Layout onBeforeAttach');
	// },
	// onAttach: function(){
	// 	console.log('=== Overview Layout onAttach');
	// },
	// onBeforeDestroy: function(){
	// 	console.log('=== Overview Layout onBeforeDestroy');
	// },
	// onDestroy: function(){
	// 	console.log('=== Overview Layout onDestroy');
	// },
});
